function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
var toString = Object.prototype.toString;
var keys = function keys(object) {
    return isObject(object) ? Object.keys(object) : [];
};
export function each(object, fn) {
    keys(object).forEach(function (key) {
        return fn(object[key], key);
    });
}
export function reduce(object, fn) {
    var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return keys(object).reduce(function (accum, key) {
        return fn(accum, object[key], key);
    }, initial);
}
export function assign(target) {
    for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
    }
    if (Object.assign) {
        return Object.assign.apply(Object, [target].concat(sources));
    }
    sources.forEach(function (source) {
        if (!source) {
            return;
        }
        each(source, function (value, key) {
            target[key] = value;
        });
    });
    return target;
}
export function isObject(value) {
    return !!value && _typeof(value) === 'object';
}
export function isPlain(value) {
    return isObject(value) && toString.call(value) === '[object Object]' && value.constructor === Object;
}